export default __webpack_public_path__ + "images/LA.e268a36.png";